import { render, staticRenderFns } from "./ConfigInputSet.vue?vue&type=template&id=84f80758&scoped=true&"
import script from "./ConfigInputSet.vue?vue&type=script&lang=js&"
export * from "./ConfigInputSet.vue?vue&type=script&lang=js&"
import style0 from "./ConfigInputSet.vue?vue&type=style&index=0&id=84f80758&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84f80758",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1477836768/src/github.com/FebosIO/Febos-AMI/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('84f80758')) {
      api.createRecord('84f80758', component.options)
    } else {
      api.reload('84f80758', component.options)
    }
    module.hot.accept("./ConfigInputSet.vue?vue&type=template&id=84f80758&scoped=true&", function () {
      api.rerender('84f80758', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/febos/global/empresas/componentes/configs/inputs/ConfigInputSet.vue"
export default component.exports